import React from "react";
import { fabric } from "fabric";
import { Button } from "@blueprintjs/core";
export function BulletPointStyle({ Canvaseditor }) {

  const addBullet = (canvas) => {
    if (!canvas) return;

    const bulletCircle = new fabric.Circle({
      radius: 4,
      fill: "#000000",
      left: 100,
      top: 100,
      originX: "center",
      originY: "center",
      selectable: true,
    });

    const bulletText = new fabric.Textbox("Bullet Text", {
      fontSize: 16,
      width: 200,
      height: 60,
      left: bulletCircle.left + 12, // 12px gap to right
      top: bulletCircle.top,
      originX: "left",
      originY: "center",
      editable: true,
      selectable: true,
      splitByGrapheme: false,
      fontFamily: "Roboto",
      fill: "black",
      _fixedWidth: 200,
      _fixedHeight: 60,
      _originalFontSize: 16,
    });

    canvas.add(bulletCircle);
    canvas.add(bulletText);
    canvas.setActiveObject(bulletText);
    canvas.renderAll();
    if (typeof canvas.fire === "function") canvas.fire("canvas:state-changed");

    // Link objects
    bulletCircle.linkedText = bulletText;
    bulletText.linkedCircle = bulletCircle;

    // Handle moving together manually
    const moveLinked = (e) => {
      const target = e.target;
      if (!target) return;

      // Move linked text if circle moved
      if (target.type === "circle" && target.linkedText) {
        target.linkedText.left = target.left + 12;
        target.linkedText.top = target.top;
        target.linkedText.setCoords();
      }

      // Move linked circle if text moved
      if (target.type === "textbox" && target.linkedCircle) {
        target.linkedCircle.left = target.left - 12;
        target.linkedCircle.top = target.top;
        target.linkedCircle.setCoords();
      }
    };

    canvas.on("object:moving", moveLinked);

    setTimeout(function () {
      document.getElementById("font-family").value = "Roboto";
      document.getElementById("text-font-size").value = 16;
    }, 0);
  };

  return (
    <>
      <Button
        icon="properties"
        text="List"
        onClick={() => addBullet(Canvaseditor)}
        style={{marginRight: "10px"}}
      />
    </>
  );
}